import { render, staticRenderFns } from "./PodcastCard.vue?vue&type=template&id=a3a8a8f6&scoped=true&"
import script from "./PodcastCard.vue?vue&type=script&lang=js&"
export * from "./PodcastCard.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCard.vue?vue&type=style&index=0&id=a3a8a8f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a8a8f6",
  null
  
)

export default component.exports